<div class="container">
  <div class="row no-gutters">
    <div class="col-12">
      <div class="d-flex popup-head align-items-center">
        <div class="d-flex align-items-center w-100 min-h55">
          <div class="popup-title pr-5" *ngIf="actionFlag === 'create'" translate>lblCreateCampaign </div>
          <div class="popup-title pr-5" *ngIf="actionFlag === 'edit'" translate>lblEditCampaign </div>
          <div class="popup-title pr-5" *ngIf="actionFlag === 'view'" translate>lblViewCampaign </div>
          <div class="font20 pl-5 border-left" *ngIf="CampaignDetails.isActive" translate><em
              class="fas fa-check text-white"></em> lblActive </div>
        </div>

        <div class="mr-2 edit-iconlist">
          <a class="close mr-3" (click)="OnClose()" translate>
            <span class="" aria-hidden="true">&times;</span>
          </a>
        </div>
      </div>

      <div class="card-accord scrollbar">
        <div class="card-content ctm-tab custom-card ">
          <ngb-accordion #a="ngbAccordion" activeIds="first" *ngIf="actionFlag === 'edit' || actionFlag === 'create'"
            class="cardOverflow" id="a">
            <!--Campaign Details-->
            <ngb-panel id="first">
              <ng-template ngbPanelHeader class="custom-header ctm">
                <div class="d-flex align-items-center">
                  <button ngbPanelToggle translate class="btn d-flex w-100 align-items-center"
                    aria-label="Center Align">
                    lblCampaignDetails
                    <ng-container *ngIf="!a.activeIds.includes('first')"><em
                        class="fas fa-angle-down fa-lg ml-auto"></em>
                    </ng-container>
                    <ng-container *ngIf="a.activeIds.includes('first')"><em class="fas fa-angle-up fa-lg ml-auto"></em>
                    </ng-container>
                  </button>
                </div>
              </ng-template>
              <ng-template ngbPanelContent>
                <form class="row" [formGroup]="campaignForm" (ngSubmit)="onSaveCustomer()">
                  <!-- Campaign Name   -->
                  <div class="col-md-4">
                    <label for="service" translate>lblCampaignName
                      <strong class="mlt6 required"> * </strong> </label>
                    <div class='lbl-info'>
                      <input type="text" class="form-control" formControlName="name">
                      <div *ngIf="cf.name.touched && cf.name.errors" class="help-block text-danger">
                        <em class="fa fa-exclamation-circle mr-1" aria-hidden="true"></em>
                        <span translate>lblCampaignnameisrequired</span>
                      </div>
                    </div>
                  </div>
                  <!-- Description -->
                  <div class="col-md-4">
                    <label for="service" translate>lblDescription</label>
                    <div class='lbl-info'>
                      <input type="text" class="form-control" formControlName="description">
                    </div>
                  </div>
                  <!--Start Date-->
                  <div class="col-md-4">
                    <label for="template-edit-startDate" translate>lblStartDate<strong class="mlt6 required"> *
                      </strong></label>
                    <div class="lbl-info cal-date">
                      <input class="form-control datePicker width100force" appAfDatepicker [format]="'d.m.Y'"
                        [dateTime]="false" formControlName="startDate" [disableNextMonthDates]="false"
                        [ngClass]="{'is-invalid':(cf.startDate.invalid  && cf.startDate.touched) || (cf.startDate.invalid)}">
                      <em class="fas fa-calendar-alt fa-lg cursordisable"></em>
                    </div>
                  </div>
                  <!-- Campaign For  -->
                  <div class="col-md-4 mt-3">
                    <label translate>lblCampaignFor</label>
                    <ng-select [multiple]="false" class="w-100 disable-clear-all" [clearable]="false"
                      [searchable]="false" formControlName="selectedFor">
                      <ng-option *ngFor="let item of campaignForList" [value]="item.id" translate>
                        {{ item.name }}
                      </ng-option>
                    </ng-select>
                  </div>
                  <!-- Campaign Via -->
                  <div class="col-md-4 mt-3">
                    <label translate>lblCampaignVia</label>
                    <ng-select [multiple]="false" class="w-100 disable-clear-all" [clearable]="false"
                      [searchable]="false" formControlName="selectedVia">
                      <ng-option *ngFor="let item of campaignViaList" [value]="item.key" translate>
                        {{ item.campaignViaCode }}
                      </ng-option>
                    </ng-select>
                  </div>
                  <!-- Campaign Type -->
                  <div class="col-md-4 mt-3">
                    <label translate>lblCampaignType</label>
                    <ng-select [multiple]="false" class="w-100 disable-clear-all" [clearable]="false"
                      [searchable]="false" (change)="onChnageType($event)" formControlName="selectedType">
                      <ng-option *ngFor="let item of campaignTypeList" [value]="item.key" translate>
                        {{ item.campaignTypeCode }}
                      </ng-option>
                    </ng-select>
                  </div>
                  <!--End Date-->
                  <div class="col-md-4 mt-3" *ngIf="cf.selectedType.value === campaignTypeList[1].key">
                    <label for="template-edit-endDate" translate>lblEndDate<strong class="mlt6 required"> *
                      </strong></label>
                    <div class="lbl-info cal-date">
                      <input class="form-control datePicker width100force" appAfDatepicker [dateTime]="false"
                        formControlName="endDate" [disableNextMonthDates]="false"
                        [ngClass]="{'is-invalid':(cf.endDate.invalid  && cf.endDate.touched) || (cf.endDate.invalid)}">
                      <em class="fas fa-calendar-alt fa-lg cursordisable"></em>
                    </div>
                  </div>
                  <!-- Execution Frequency -->
                  <div class='col-md-4 mt-3' *ngIf="cf.selectedType.value === campaignTypeList[1].key">
                    <label translate>lblExecutionFrequency</label>
                    <ng-select [multiple]="false" class="w-100 disable-clear-all" [clearable]="false"
                      [searchable]="false" formControlName="selectedFrequency">
                      <ng-option *ngFor="let item of frequencyList" [value]="item.key" translate>
                        {{ item.value }}
                      </ng-option>
                    </ng-select>
                  </div>
                </form>
              </ng-template>
            </ngb-panel>
            <!--Include Recipients-->
            <ngb-panel id="second">
              <ng-template ngbPanelHeader class="custom-header ctm">
                <div class="d-flex align-items-center w-100 ">
                  <button ngbPanelToggle translate class="btn d-flex w-100 align-items-center"
                    aria-label="Center Align">
                    lblIncludeRecipients
                    <ng-container *ngIf="!a.activeIds.includes('second')"><em
                        class="fas fa-angle-down fa-lg ml-auto"></em>
                    </ng-container>
                    <ng-container *ngIf="a.activeIds.includes('second')"><em class="fas fa-angle-up fa-lg ml-auto"></em>
                    </ng-container>
                  </button>
                </div>
              </ng-template>
              <ng-template ngbPanelContent>
                <!-- Target Group Selection -->
                <div class="row">
                  <div class="col-md-3 ">
                    <ng-select [multiple]="false" class="w-100" placeholder="{{ 'lblSelectTargetedGroup' | translate }}"
                      (change)="onTargetedGroupChange($event)" [disabled]='CampaignDetails.isActive'>
                      <ng-option *ngFor="let item of targetedGroups" [value]="item.id" translate>
                        {{ item.name }}
                      </ng-option>
                    </ng-select>
                  </div>
                  <div class="col-md-6" *ngIf='!CampaignDetails.isActive'>
                    <a href="/targetedgroup" target="_blank" translate class="btn btn-outline-primary mr-3 nowrap"
                      *ngIf="a.activeIds.includes('second')">
                      <em class="fas fa-plus"></em> lblAddTargetedGroup
                    </a>
                  </div>
                </div>
                <!--Query Builder-->
                <div class="bg-grey p-1 relative mt-3">
                  <div class="d-flex align-items-center">
                    <div class="flex-grow-1 ">
                      <query-builder [formControl]='includeQueryCtrl' [classNames]='classNames' [config]='config'
                        [disabled]='CampaignDetails.isActive' [allowRuleset]='true' [allowCollapse]='true'>
                      </query-builder>
                    </div>
                  </div>
                  <div *ngIf="!validationModel.cmpInvalidIncludeQuery" class="help-block text-danger">
                    <em class="ft-alert-circle align-middle" aria-hidden="true"></em><span
                      translate>lblQueryIsNotValid</span>
                  </div>
                </div>
                <!-- Customer -->
                <div class="row">
                  <div class="col-md-6 my-3">
                    <button type="button" translate class="btn btn-primary nowrap" (click)="viewCustomer(true, true)"
                      aria-label="Center Align">
                      <em class="fas fa-eye"></em> lblViewCustomer
                    </button>
                  </div>
                  <div class="col-md-6 my-3 text-right">
                    <button type="button" translate class="btn btn-primary mr-3" [disabled]='CampaignDetails.isActive'
                      (click)="AddCustomerModel('Add')" aria-label="Center Align">
                      <em class="fas fa-plus"></em> lblAddCustomer
                    </button>
                    <button type="button" translate class="btn btn-outline-primary "
                      [disabled]='CampaignDetails.isActive' (click)="AddCustomerModel('Import')"
                      aria-label="Center Align">
                      <em class="fas fa-file-import"></em> lblImportCustomer
                    </button>
                  </div>
                </div>
                <div *ngIf="!validationModel.cmpReqIncludeQuery" class="help-block text-danger">
                  <em class="ft-alert-circle align-middle" aria-hidden="true"></em><span
                    translate>lblCustomerRequiredError</span>
                </div>
                <div>
                  <div class="row mt-2">
                    <div class="col-md-12 d-flex justify-content-between">
                      <h2 class="title16 text-primary" translate> lblIncludedRecipient </h2>
                      <div class="font16 fontbold">
                        <span class="font16 fontnormal" translate>lblTotal</span>:&nbsp;{{
                        incTotalCount
                        }}&nbsp;<span class="font16 fontnormal" translate>lblResults</span>
                      </div>
                    </div>
                  </div>
                  <!--Recipients List-->
                  <div class="row no-gutters">
                    <div class="col-md-12">
                      <div class="mt-3 mx-2">
                        <div class="table-responsive max-vh20 p-0 border" id="scrollDiv" infinite-scroll
                          [infiniteScrollDistance]="scrollDistance" [infiniteScrollThrottle]="throttle"
                          [scrollWindow]="false" (scrolled)="onScrollDown($event, true)">
                          <table class="tablest1 fixed-header">
                            <thead>
                              <tr>
                                <th scope="col" style="width: 30px;">#</th>
                                <th scope="col" translate>lblName</th>
                                <th scope="col" translate>lblEmail</th>
                                <th scope="col" translate>lblMobile</th>
                                <th scope="col" translate>lblCity</th>
                                <th class="text-center" scope="col" translate>lblEmailConsent</th>
                                <th class="text-center" scope="col" translate>lblSMSConsent</th>
                              </tr>
                            </thead>
                            <tbody>
                              <ng-container *ngIf="includedRecipientList?.length>0; else load_else">
                                <tr *ngFor="let member of includedRecipientList; let i = index">
                                  <td>{{ i+1 }}</td>
                                  <td>{{ member.name }}</td>
                                  <td>{{ member.email }}</td>
                                  <td>{{ member.mobile }}</td>
                                  <td>{{ member.city }}</td>
                                  <td class="text-center">{{ member.emailConsent }}</td>
                                  <td class="text-center">{{ member.smsConsent }}</td>
                                </tr>
                              </ng-container>
                              <ng-template #load_else>
                                <tr>
                                  <td colspan="8" class="no-record" translate>lblNoRecordsFound</td>
                                </tr>
                              </ng-template>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
            </ngb-panel>
            <!--Campaign Steps-->
            <ngb-panel id="third">
              <ng-template ngbPanelHeader class="custom-header ctm">
                <div class="d-flex align-items-center">
                  <button ngbPanelToggle translate class="btn d-flex w-100 align-items-center"
                    aria-label="Center Align">
                    lblCampaignSteps
                    <ng-container *ngIf="!a.activeIds.includes('third')"><em
                        class="fas fa-angle-down fa-lg ml-auto"></em>
                    </ng-container>
                    <ng-container *ngIf="a.activeIds.includes('third')"><em class="fas fa-angle-up fa-lg ml-auto"></em>
                    </ng-container>
                  </button>
                </div>
              </ng-template>
              <ng-template ngbPanelContent>
                <!-- Executein Steps  -->
                <div class="row" *ngIf="cf.selectedVia.value == campaignViaList[2].key">
                  <div class="col-md-6">
                    <div class="custom-control custom-radio">
                      <input type="radio" id="customRadio1a" name="customRadio" [(ngModel)]="isExecuteInStep"
                        [value]="true" [disabled]='CampaignDetails.isActive' (change)="onExecutionTypeChange()"
                        class="custom-control-input">
                      <label class="custom-control-label" for="customRadio1a" translate>lblExecuteinSteps</label>
                    </div>
                    <p class="pl30" translate>lblExecuteinStepsNote</p>
                  </div>
                  <div class="col-md-6">
                    <div class="custom-control custom-radio">
                      <input type="radio" id="customRadio2a" name="customRadio" [(ngModel)]="isExecuteInStep"
                        [value]="false" [disabled]='CampaignDetails.isActive' (change)="onExecutionTypeChange()"
                        class="custom-control-input">
                      <label class="custom-control-label" for="customRadio2a" translate>lblExecuteParallel</label>
                    </div>
                    <p class="pl30" translate>lblExecuteParallelNote</p>
                  </div>
                </div>

                <div class="border bg-white pad15 d-flex align-items-start mt-3">
                  <div class="flex-grow-1 ">
                    <div *ngIf="!validationModel.cmpStep" class="help-block text-danger">
                      <em class="ft-alert-circle align-middle" aria-hidden="true"></em><span
                        translate>lblAtleaseonestepisrequired</span>
                    </div>
                    <div class="row" *ngFor="let activity of CampaignActivity; let i = index"
                      id="step{{activity.stepNo}}">
                      <div class="ml-3 mt-40" *ngIf="isExecuteInStep">
                        <a class="btn btn-default" ngbTooltip="{{'lblDelete' | translate}}" placement="top"
                          [class.disabled]='CampaignDetails.isActive' (click)="deleteStep(activity.stepNo)">
                          <em class="far fa-times-circle text-danger fa-lg"></em>
                        </a>
                      </div>
                      <div class="col-md-5">
                        <div class="form-row my-3">
                          <div class="col-md-12">
                            <h2 class="title16 text-primary" *ngIf="activity.stepType == 1" translate>lblEmail</h2>
                            <h2 class="title16 text-primary" *ngIf="activity.stepType == 2" translate>lblSms</h2>
                          </div>
                          <div class='col-md-6 mt-2'>
                            <label translate>lblStepDescription <strong class="mlt6 required"> * </strong></label>
                            <input type="text" class="form-control" [(ngModel)]="activity.description"
                              [disabled]='CampaignDetails.isActive'>
                            <div class="help-block text-danger">
                              <em class="ft-alert-circle align-middle" aria-hidden="true"></em>
                              <span id="{{activity.stepNo}}descriptionError" translate></span>
                            </div>
                          </div>

                          <div class='col-md-6 mt-30'>
                            <button type="button" class="btn btn-outline-primary minw215"
                              [disabled]='CampaignDetails.isActive'
                              (click)="EmailTemplateModel(activity.stepNo, activity.stepType)">
                              <em class="fas fa-envelope-open-text"></em>
                              <span id="templateBtn{{activity.stepNo}}" *ngIf="activity.stepType == 1" translate>
                                lblSelectEmailTemplate </span>
                              <span id="templateBtn{{activity.stepNo}}" *ngIf="activity.stepType == 2" translate>
                                lblSelectSMSTemplate </span>
                            </button>
                            <div class="help-block text-danger">
                              <em class="ft-alert-circle align-middle" aria-hidden="true"></em>
                              <span id="{{activity.stepNo}}templateError" translate></span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6" *ngIf="i < 2 && isExecuteInStep">
                        <div class="form-row my-3">
                          <div class="col-md-12">
                            <h2 class="title16 text-primary" translate>lblWait</h2>
                          </div>
                          <div class='col-md-2 mt-2'>
                            <label translate>lblWaitforDays</label>
                            <input type="number" class="form-control" [(ngModel)]="activity.waitDays" min="1"
                              [disabled]='CampaignDetails.isActive'
                              (change)="activity.waitDays = activity.waitDays == 0 ? 1 : activity.waitDays">
                          </div>
                          <div class='col-md-4 mt-2'>
                            <label translate>lblCondition</label>
                            <select class="custom-select mx-2" [(ngModel)]="activity.waitCondition"
                              [disabled]='CampaignDetails.isActive'>
                              <option [ngValue]="waitCondition.MailSent" translate *ngIf="activity.stepType == 2">
                                lblSMSSent</option>
                              <option [ngValue]="waitCondition.MailSent" translate *ngIf="activity.stepType == 1">
                                lblMailSent</option>
                              <option [ngValue]="waitCondition.MailOpened" translate *ngIf="activity.stepType == 1">
                                lblMailOpened</option>
                              <option [ngValue]="waitCondition.Clicked" translate *ngIf="activity.stepType == 1">
                                lblClicked</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="my-3" *ngIf="isExecuteInStep">
                      <button type="button" class="btn btn-primary nowrap" (click)="addStep(campaignViaList[0].key)"
                        *ngIf="cf.selectedVia.value != campaignViaList[1].key" translate
                        [disabled]="CampaignActivity.length > 2 || CampaignDetails.isActive">
                        <em class="fas fa-eye"></em> lblAddEmail
                      </button>
                      <button type="button" class="btn btn-primary nowrap ml-3"
                        (click)="addStep(campaignViaList[1].key)" *ngIf="cf.selectedVia.value != campaignViaList[0].key"
                        translate [disabled]="CampaignActivity.length > 2 || CampaignDetails.isActive">
                        <em class="fas fa-eye"></em> lblAddSMS
                      </button>
                    </div>
                  </div>
                </div>
                <!-- /End Filter Group row -->
              </ng-template>
            </ngb-panel>
            <!--Exclude Recipients-->
            <ngb-panel id="four">
              <ng-template ngbPanelHeader class="custom-header ctm">
                <div class="d-flex align-items-center">
                  <button ngbPanelToggle translate class="btn d-flex w-100 align-items-center"
                    aria-label="Center Align">
                    lblExcludeRecipients
                    <ng-container *ngIf="!a.activeIds.includes('four')"><em
                        class="fas fa-angle-down fa-lg ml-auto"></em>
                    </ng-container>
                    <ng-container *ngIf="a.activeIds.includes('four')"><em class="fas fa-angle-up fa-lg ml-auto"></em>
                    </ng-container>
                  </button>
                </div>
              </ng-template>
              <ng-template ngbPanelContent>
                <div class="bg-grey p-1 relative mt-3">
                  <div class="d-flex align-items-center">
                    <div class="flex-grow-1 ">
                      <query-builder [formControl]='excludeQueryCtrl' [classNames]='classNames' [config]='config'
                        [allowRuleset]='true' [disabled]='CampaignDetails.isActive' [allowCollapse]='true'>
                      </query-builder>
                    </div>
                  </div>
                  <div *ngIf="!validationModel.cmpInvalidExcludeQuery" class="help-block text-danger">
                    <em class="ft-alert-circle align-middle" aria-hidden="true"></em><span
                      translate>lblQueryIsNotValid</span>
                  </div>
                </div>

                <div class="my-3">
                  <button type="button" translate class="btn btn-primary nowrap"
                    [disabled]="this.excludeJSON.rules.length == 0" (click)="viewCustomer(true, false)">
                    <em class="fas fa-eye"></em> lblViewCustomer
                  </button>
                </div>

                <div>
                  <div class="row mt-2">
                    <div class="col-md-12 d-flex justify-content-between">
                      <h2 class="title16 text-primary" translate> lblExcludedRecipients </h2>
                      <div class="font16 fontbold">
                        <span class="font16 fontnormal" translate>lblTotal</span>:&nbsp;{{
                        excTotalCount
                        }}&nbsp;<span class="font16 fontnormal" translate>lblResults</span>
                      </div>
                    </div>
                  </div>
                  <div class="row no-gutters">
                    <div class="col-md-12">
                      <div class="mt-3">
                        <div class="table-responsive max-vh20 p-0 border" id="scrollDiv" infinite-scroll
                          [infiniteScrollDistance]="scrollDistance" [infiniteScrollThrottle]="throttle"
                          [scrollWindow]="false" (scrolled)="onScrollDown($event, false)">
                          <table class="tablest1 fixed-header">
                            <thead>
                              <tr>
                                <th scope="col" style="width: 30px;">#</th>
                                <th scope="col" translate>lblName</th>
                                <th scope="col" translate>lblEmail</th>
                                <th scope="col" translate>lblMobile</th>
                                <th scope="col" translate>lblCity</th>
                                <th class="text-center" scope="col" translate>lblEmailConsent</th>
                                <th class="text-center" scope="col" translate>lblSMSConsent</th>
                              </tr>
                            </thead>
                            <tbody>
                              <ng-container *ngIf="excludedRecipientList?.length>0; else load_else">
                                <tr *ngFor="let member of excludedRecipientList; let i = index">
                                  <td>{{ i+1 }}</td>
                                  <td>{{ member.name }}</td>
                                  <td>{{ member.email }}</td>
                                  <td>{{ member.mobile }}</td>
                                  <td>{{ member.city }}</td>
                                  <td class="text-center">{{ member.emailConsent }}</td>
                                  <td class="text-center">{{ member.smsConsent }}</td>
                                </tr>
                              </ng-container>
                              <ng-template #load_else>
                                <tr>
                                  <td colspan="7" class="no-record" translate>lblNoRecordsFound</td>
                                </tr>
                              </ng-template>
                            </tbody>
                          </table>
                        </div>
                        <div class="card-footer">
                          <div class="d-flex justify-content-between">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
            </ngb-panel>
          </ngb-accordion>

          <!--View Page-->
          <div class="card" *ngIf="actionFlag === 'view'">
            <div class="card-header d-flex" translate> lblCampaignDetails </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-4">
                  <div class="af-form-group">
                    <label translate>lblCampaignName</label>
                    <div class="lbl-info"> {{CampaignDetails.name}} </div>
                  </div>
                </div>
                <div class="col-md-8">
                  <div class="af-form-group" *ngIf="CampaignDetails.description != ''">
                    <label translate>lblDescription</label>
                    <div class="lbl-info"> {{CampaignDetails.description}}</div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="af-form-group">
                    <label translate>lblCampaignFor</label>
                    <div class="lbl-info">{{campaignFor[CampaignDetails.campaignFor]}}</div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="af-form-group">
                    <label translate>lblCampaignVia</label>
                    <div class="lbl-info">{{campaignVia[CampaignDetails.campaignVia]}}</div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="af-form-group">
                    <label translate>lblCampaignType</label>
                    <div class="lbl-info">{{campaignType[CampaignDetails.campaignType]}}</div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="af-form-group">
                    <label translate>lblExecutionDate</label>
                    <div class="lbl-info">
                      {{CampaignDetails.startDate | date:'dd.MM.yyyy'}}
                      <span *ngIf="CampaignDetails.campaignType == campaignType.Recurring">
                        To {{CampaignDetails.endDate | date:'dd.MM.yyyy'}}
                      </span>
                    </div>
                  </div>
                </div>
                <div class="col-md-4" *ngIf="CampaignDetails.campaignType == campaignType.Recurring">
                  <div class="af-form-group">
                    <label translate>lblExecutionFrequency</label>
                    <div class="lbl-info">{{executionFrequency[CampaignDetails.executionFrequency]}}</div>
                  </div>
                </div>

                <div class="col-md-12">
                  <div class="af-form-group">
                    <p class="font16 font-weight-bold" translate>lblTotalRecipients
                      <a class="btn btn-ico " (click)="showCustomerOnView(content,'include', true)">
                        <em class="fas fa-eye fa-lg"></em>
                        <span class="position-absolute translate-middle badge rounded-pill count"
                          style="margin-top: -6px !important; background-color: #ED5153; color: #ffff;">
                          {{totalRecipientCount}} </span>
                      </a>

                    </p>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="af-form-group">
                    <p class="font16 font-weight-bold" translate>lblExcludedRecipients
                      <a class="btn btn-ico " (click)="showCustomerOnView(content,'exclude', true)">
                        <em class="fas fa-eye fa-lg"></em>
                        <span class="position-absolute translate-middle badge rounded-pill count"
                          style="margin-top: -6px !important; background-color: #ED5153; color: #ffff;">
                          {{excludedRecipientCount}} </span>
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="title16 text-primary d-flex mt-3" *ngIf="actionFlag === 'view'" translate>
            lblPreviewbySteps
          </div>
          <div *ngIf="actionFlag === 'view'">
            <nav ngbNav #nav="ngbNav"  [destroyOnHide]="false" class="mt-3">
              <ng-container *ngFor="let item of CampaignActivity; let i = index">
                <a ngbNavLink>
                  <strong class="badge badge-primary badge-pill">{{item.stepNo}}</strong>
                  {{item.description}}
                </a>
                <ng-template ngbNavContent>
                  <div class="card">
                    <div class="card-header mt-3" *ngIf="item.statisticsJson">
                      <div class="row">
                        <div class="col-3"></div>
                        <div class="col-6">
                          <div class="row text-center">
                            <div class="col-2">
                              <div class="row">
                                <div class="col-12 text-center" translate>lblSent</div>
                                <div class="col-12 text-center">{{item.statisticsJson.Sent}}</div>
                              </div>
                            </div>
                            <div class="col-2">
                              <div class="row">
                                <div class="col-12 text-center" translate>lblOpened</div>
                                <div class="col-12 text-center">{{item.statisticsJson.Opened}}</div>
                              </div>
                            </div>
                            <div class="col-2">
                              <div class="row">
                                <div class="col-12 text-center" translate>lblClicked</div>
                                <div class="col-12 text-center">{{item.statisticsJson.Clicked}}</div>
                              </div>
                            </div>
                            <div class="col-3">
                              <div class="row">
                                <div class="col-12 text-center" translate>lblBounced</div>
                                <div class="col-12 text-center">{{item.statisticsJson.Bounced}}</div>
                              </div>
                            </div>
                            <div class="col-3">
                              <div class="row">
                                <div class="col-12 text-center" translate>lblUnsubscribed</div>
                                <div class="col-12 text-center">{{item.statisticsJson.Unsubscribed}}</div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-3"></div>
                      </div>
                    </div>
                    <hr>
                    <div class="card-body">
                      <div [innerHTML]="item.template"></div>
                    </div>
                  </div>
                </ng-template>
              </ng-container>
            </nav>
            <div [ngbNavOutlet]="nav"></div>
          </div>
        </div>
      </div>

      <!--Footer-->
      <div class="p-3 bg-light pp-footer-top-brdr">
        <div class="row">
          <div class="col-6 d-flex flex-sm-row flex-column mb15">
            <button type="submit" class="btn btn-primary btn-lg" aria-label="Center Align" (click)="backEdit()"
              *ngIf="actionFlag === 'view' && showSaveAndExecute" translate><em
                class="far fa-arrow-left font16 align-top mr-2"></em> lblBack</button>
            <button type="submit" class="btn btn-danger btn-lg" aria-label="Center Align"
              (click)="CampaignDetails.isActive = false" *ngIf="actionFlag != 'view' && CampaignDetails.isActive"
              translate>lblDeactivate</button>
          </div>
          <div class="col-6 d-flex flex-sm-row flex-column mb15">
            <div class="d-flex ml-auto">
              <button type="submit" class="btn btn-primary btn-lg mr-sm-2 ml-auto" aria-label="Center Align"
                (click)="onConfirm(validationPopup)" *ngIf="actionFlag == 'view' && !CampaignDetails.isActive">
                <span *ngIf="CampaignDetails.campaignType != 3" translate> lblActivateCampaign </span>
                <span *ngIf="CampaignDetails.campaignType == 3" translate>lblExecuteCampaign</span>
              </button>
              <button type="submit" class="btn btn-primary btn-lg mr-sm-2" aria-label="Center Align"
                (click)="saveandNext()" *ngIf="actionFlag != 'view' && !CampaignDetails.isActive" translate><em
                  class="far fa-save font16 align-top mr-2"></em> lblSaveandNext</button>
              <button type="submit" class="btn btn-primary btn-lg mr-sm-2" aria-label="Center Align" (click)="onNext()"
                *ngIf="actionFlag != 'view' && CampaignDetails.id != undefined && CampaignDetails.id > 0" translate><em
                  class="fa fa-arrow-circle-right font16 align-top mr-2"></em> lblNext</button>
              <a (click)="OnClose()" class="btn btn-secondary btn-lg " translate><em
                  class="far fa-times-circle font16 align-top mr-2"></em> lblCancel</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!--Customer List Popup for View-->
<ng-template #content let-modal>
  <div class="modal-header">
    <h4 class="modal-title">{{modelHeader}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.close()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-12">
        <div class="font16 fontbold text-right">
          <span class="font16 fontnormal" translate>lblTotal</span>:&nbsp;{{
          typeOfCustomer == 'exclude' ? excludedRecipientCount : totalRecipientCount
          }}&nbsp;<span class="font16 fontnormal" translate>lblResults</span>
        </div>
      </div>
      <div class="col-md-12">
        <div class="mt-0">
          <div class="table-responsive max-h415 p-0 border" id="scrollDiv" infinite-scroll
            [infiniteScrollDistance]="scrollDistance" [infiniteScrollThrottle]="throttle" [scrollWindow]="false"
            (scrolled)="onViewCustomerScrollDown($event)">
            <table class="tablest1">
              <thead class="stick-header">
                <tr>
                  <th scope="col" style="width: 30px;">#</th>
                  <th scope="col" translate>lblName</th>
                  <th scope="col" translate>lblEmail</th>
                  <th scope="col" translate>lblMobile</th>
                  <th class="text-center" scope="col" translate>lblCity</th>
                  <th class="text-center" scope="col" translate>lblEmailConsent</th>
                  <th class="text-center" scope="col" translate>lblSMSConsent</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let member of campaignMembers; let i = index">
                  <td>{{ i+1 }}</td>
                  <td>{{ member.name }}</td>
                  <td>{{ member.email }}</td>
                  <td>{{ member.mobile }}</td>
                  <td class="text-center">{{ member.city }}</td>
                  <td class="text-center">{{ member.emailConsent }}</td>
                  <td class="text-center">{{ member.smsConsent }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="card-footer">
            <div class="d-flex justify-content-between">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" aria-label="Center Align" (click)="modal.close()"
      translate>lblClose</button>
  </div>
</ng-template>

<!--Validation Popup-->
<ng-template #validationPopup let-modal>
  <div class="modal-header">
    <h4 class="modal-title" translate>lblValidationForActivation</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.close(); openPenelForValidation()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="ml-2">
      <span translate>lblToActivatetheCampaign</span>
    </div>
    <div class="ml-4" *ngIf="!validationModel.cmpReqIncludeQuery">
      - <span translate>lblCustomersareRequired</span>
    </div>
    <div class="ml-4" *ngIf="!validationModel.cmpStep">
      - <span translate>lblAtleaseonestepisrequired</span>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" aria-label="Center Align"
      (click)="modal.close(); openPenelForValidation()" translate>lblClose</button>
  </div>
</ng-template>